import React, { useState } from "react";
import { ListFilterValuesContext } from "../../hooks/list/ListFilterValuesContext";
import { useDataSearchFilterValues } from "./hooks/useDataSearchFilterValues";
import { DataSearch, DataSearchTab } from "./DataSearch";

export function DataSearchWrapper() {
  const { filterValues, pageInfoOnFilter, searchList, listQueryType } = useDataSearchFilterValues();
  const [activeTab, setActiveTab] = useState<DataSearchTab>(DataSearchTab.TEST_RESULT);

  return (
    <ListFilterValuesContext.Provider
      value={{
        filterValues,
        pageInfoOnFilter,
        searchList,
        listQueryType,
      }}
    >
      <DataSearch activeTab={activeTab} setActiveTab={setActiveTab} />
    </ListFilterValuesContext.Provider>
  );
}
